export const getCurrentYear = () => {
    const todayDate = new Date();
    const year = todayDate.getFullYear();
    return year;
}

export const handleScrollToTop = () => {
    if (typeof window !== 'undefined') {
        window.scrollTo(0, 0);
    }
};

export const controlScrollDynamic = idSelector => {
    const scrollToTopButton = document.querySelector(`.${idSelector}`);
    window.addEventListener('scroll', () => {
        const scrollY = window.scrollY || window.pageYOffset;
        if (scrollY >= 0) {
            scrollToTopButton.style.display = 'block';
            scrollToTopButton.classList.add('fade-in');
        } else {
            scrollToTopButton.style.display = 'none';
            scrollToTopButton.classList.remove('fade-in');
        }
    });
}

export const languages = {
    spanish: 'es',
    english: 'en',
    german: 'de'
}

const {
    spanish,
    english,
    german
} = languages

export const countryToLanguage = {
    'Spain': spanish,
    'Mexico': spanish,
    'Colombia': spanish,
    'Argentina': spanish,
    'Peru': spanish,
    'Venezuela': spanish,
    'Chile': spanish,
    'Guatemala': spanish,
    'Cuba': spanish,
    'Bolivia': spanish,
    'Dominican Republic': spanish,
    'Honduras': spanish,
    'Paraguay': spanish,
    'El Salvador': spanish,
    'Nicaragua': spanish,
    'Costa Rica': spanish,
    'Puerto Rico': spanish,
    'Panama': spanish,
    'Uruguay': spanish,
    'Equatorial Guinea': spanish,
    'Germany': german,
    'Austria': german,
    'Switzerland': german,
    'Luxembourg': german,
    'Liechtenstein': german,
    'Belgium': german
};

export const getLanguageFromCountry = (countryName) => {
    const language = countryToLanguage[countryName];
    if (language) return language
    return english
}